import AWSPortOpeningRule from '../../../models/entities/AWSPortOpeningRule';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';

export type PORColumn = {
	header: string;
	cell: (rule: AWSPortOpeningRule) => string;
	limit?: number;
};

function defaultColumnsLayout () {
	return [
		{
			header: 'Rule Name',
			cell: (rule: AWSPortOpeningRule) => rule.awsName ? rule.awsName : rule.name,
			limit: 20,
		},
		{
			header: 'Operation',
			cell: (rule: AWSPortOpeningRule) => rule.operation?.name,
		},
		{
			header: 'Region',
			cell: (rule: AWSPortOpeningRule) => rule.region?.name,
		},
		{
			header: 'Action',
			cell: (rule: AWSPortOpeningRule) => rule.action?.name,
		},
		{
			header: 'Source IP',
			cell: (rule: AWSPortOpeningRule) => rule.sourceIPs,
			limit: 15,
		},
		{
			header: 'Destination IP',
			cell: (rule: AWSPortOpeningRule) => rule.destinationIPs,
			limit: 15,
		},
		{
			header: 'Destination (URLs)',
			cell: (rule: AWSPortOpeningRule) => rule.destinationURLs,
			limit: 15,
		},
		{
			header: 'Destination Port(s) for Protocol 1',
			cell: (rule: AWSPortOpeningRule) => rule.destinationPorts && rule.destinationPorts[0] ? rule.destinationPorts[0].destinationPorts : '',
		},
		{
			header: 'Protocol 1',
			cell: (rule: AWSPortOpeningRule) => rule.destinationPorts && rule.destinationPorts[0] ? rule.destinationPorts[0].protocol : '',
		},
		{
			header: 'Description',
			cell: (rule: AWSPortOpeningRule) => rule.description,
			limit: 20,
		},
	]
}

function sourceURLSColumnLayout () {
	const newColumn = {
		header: 'Source URLs',
		cell: (rule: AWSPortOpeningRule) => rule.sourceURLs,
		limit: 10,
	};

	const defaultLayout = defaultColumnsLayout() 
	defaultLayout.splice(5, 0, newColumn)

	return defaultLayout;
}

function trafficDirectionColumnLayout () {
	const newColumn = {
		header: 'Traffic Direction',
		cell: (rule: AWSPortOpeningRule) => rule.trafficDirection.name,
		limit: 10,
	};

	const defaultLayout = defaultColumnsLayout() 
	defaultLayout.splice(8, 0, newColumn)

	return defaultLayout;
}

export const RuleColumnsLayout = new Map<PortOpeningRequestsDirection, PORColumn[]>();

RuleColumnsLayout.set(PortOpeningRequestsDirection.TrustedToInternet, defaultColumnsLayout());
RuleColumnsLayout.set(PortOpeningRequestsDirection.GLLAWSToGLLAWS, defaultColumnsLayout())
RuleColumnsLayout.set(PortOpeningRequestsDirection.UntrustedToInternet, defaultColumnsLayout())
RuleColumnsLayout.set(PortOpeningRequestsDirection.ExternalAccounts, defaultColumnsLayout())

RuleColumnsLayout.set(PortOpeningRequestsDirection.InternetToDMZNorth, sourceURLSColumnLayout());
RuleColumnsLayout.set(PortOpeningRequestsDirection.DMZToInternetSouthObi, sourceURLSColumnLayout());
RuleColumnsLayout.set(PortOpeningRequestsDirection.DMZTrustedToL4South, sourceURLSColumnLayout());

RuleColumnsLayout.set(PortOpeningRequestsDirection.GLLOnPremToGLLAWS, trafficDirectionColumnLayout())
RuleColumnsLayout.set(PortOpeningRequestsDirection.GLLAWSToGLUizL4, trafficDirectionColumnLayout())
RuleColumnsLayout.set(PortOpeningRequestsDirection.UntrustedToL4, trafficDirectionColumnLayout())

